module.exports = __webpack_public_path__ + "assets/img/icon5-menu.1f44d543.svg";